import { useCallback } from "react";
import { convertToCSV, downloadCSV } from "./csvExporter";
import { errorToast } from "./toastHelper";
import { postApi } from "./services";

export default function useCsvExport({
  api,
  getPayload,
  mapData,
  fileName,
  getParams
}) {
  return useCallback(async () => {
    try {
      const payload = getPayload?.();

      const { data, error } = await postApi(
        typeof api === "function" ? api() : api,
        payload,
        getParams?.()
      );

      if (error) return errorToast("Download failed.");
      if (!data?.length) return errorToast("No data to export.");

      const exportData = mapData(data);

      const csv = convertToCSV(exportData);
      downloadCSV(csv, fileName);

    } catch (err) {
      errorToast("Unexpected error during export.");
    }
  }, [api, getPayload, mapData, fileName, getParams]);
}